<template>
	<div class="tab_box">
		<!-- 操作按钮 -->
		<list-btn
    :uploadUrl="uploadUrl"
    :downloadUrl="downloadUrl"
    :postExcelData="postExcelData"
    @uploadExcel="uploadExcel"
    @uploadBtn="uploadBtn"
		@add="add"
		@del="del"
    isAdd
    isDel
    isExcel
    ref="actionbtn"
		></list-btn>
		<el-dialog width="900px" customClass="dialog_detail_style" title="选择物料" :visible.sync="dialogSelectMatters" @close='cancelSelect' v-dialogDrag>
			<matter-stock-list
		  class="contnet_box"
		  ref="selectMatter"
		  :searchCriteria="searchCriteria"
		  :selectedList="selectedList"
		  @getSelect="getSelect"
			></matter-stock-list>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelSelect">取 消</el-button>
				<el-button type="primary" @click="selectMattersOk">确 定</el-button>
			</div>
		</el-dialog>

    <!-- 错误的表格-->
    <!-- <el-button type="text" @click="dialogTableVisible = true">打开嵌套表格的 Dialog</el-button> -->
    <el-dialog title="错误的上传数据" :visible.sync="isExcelError" width="900px">
      <tab-list :tabList="excelErrorList" :columns="excelErrorTabColumns" isno nheight="400">
      </tab-list>
    </el-dialog>

    <!-- 可编辑的表格 -->
    <edit-tab-list ref="editTabList" :columns="tabColums" :listArr="selectedMatterStockList" style="width:100%;"></edit-tab-list>
	</div>
</template>

<script>
import {excelUpload,excelDownload} from 'api/excel.js'
import listBtn from 'components/btn/listBtn.vue';
import matterStockList from 'components/matters/stockList.vue';
import tabList from 'components/table/list.vue';
import editTabList from 'components/table/vxeTab.vue';

import { mapState, mapActions } from 'vuex'
export default{
	components:{
		listBtn,
		matterStockList,
		tabList,
		editTabList
	},
  props:{
    fromData:Object,
    noFromData:Object,
  },
  computed:{
    ...mapState("cache",['selectedMatterStockList'])
  },
	data(){
		return {
      dialogSelectMatters:false,
	    searchCriteria:{},
      selectList:[],//所选数据
      selectedList:[],//已选数据
      sdata:{},//已选中的
      postExcelData:{},//EXCEL上传时所需传递的参数
      downloadUrl:excelDownload.saleOutStock,
      uploadUrl:excelUpload.saleOutStock,
      /* 错误的表格表头*/
      excelErrorTabColumns:[
        {field: 'excelRow', title: 'excel行号',width:100,"sortable":true},
        {field: 'errorDesc', title: '错误信息'},
        {field: 'materialCode', title: '物料编码',width:110},
        {field: 'materialDesc', title: '物料描述'},
        {field: 'quantity', title: '数量',width:50},

        {field: 'currencyCode', title: '币种',width:50},
        {field: 'basicUnitDesc', title: '基本单位',width:80},
        {field: 'specifications', title: '规格'},
        {field: 'projectTxt', title: '备注'}
      ],
      excelErrorList:[],
      isExcelError:false,//是否有上传错误的数据
      tabColums:[
        {field:"materialCode",title:"物料编码",width:100},
        {field:"materialDesc",title:"物料描述"},
        {field:"materialGroupDesc",title:"物料组",width:80},
        {field:"materialTypeName",title:"物料类型",width:80},
        {field:"availableStock",title:"库存数量",width:100},
       /* {field:"quantity",title:"数量",width:100,isEdit:true,oninput:function(row){
          if(row){
            console.log(row.availableStock,6666);
            let temp = row.quantity +'';
            temp = temp.replace(/[^\d]/g,'');
            if(temp >  row.availableStock) temp = row.availableStock;
            row.quantity = temp;
          }
        }}, */
        {field:"quantity",title:"数量",width:100,isEdit:true,type:"input"},
        {field:"basicUnitDesc",title:"基本单位",width:80},
        {field: 'currencyCode', title: '币种', width: 100,
        formatter: function (rowData,rowIndex,pagingIndex,field) {
          return "CNY";
        }},
        {field:"specifications",title:"规格",width:80},
        {field:"projectTxt",title:"备注",width:160,isEdit:true,type:"input"},
      ]
		};
	},
  created(){

  },
  mounted: function () {
     this.$nextTick(function () {

     })
   },
   updated:function(){
   },
	methods:{
    ...mapActions('cache',['setSelectedMatterStockList']),
		//选中数据
		selectSdata(data){
		  this.sdata = data;
		},
		//获取所选
		getSelect(res){
		  this.selectList = res;
		},
    //确定所选
    selectMattersOk(){
      this.setSelectedMatterStockList({
        "arr":this.selectList,
        other:{
          "factoryCode":this.fromData.factoryCode,//工厂
          "factoryDesc":this.fromData.factoryDesc,
          "factoryId":this.fromData.factoryId,

          "inventoryCode":this.fromData.inventoryCode,//库存地
          "inventoryDesc":this.fromData.inventoryDesc,
          "inventoryId":this.fromData.inventoryId,

          "customerCode":this.fromData.customerCode,//客户
          "customerDesc":this.fromData.customerDesc,
          "customerId":this.fromData.customerId

        }
      });
      this.dialogSelectMatters = false;
    },
    //取消所选
    cancelSelect(){
      this.$refs.selectMatter.cancelSelect();
      this.dialogSelectMatters = false;
    },
    add(){
      //this.dialogSelectMatters = true;return;
      if(!this.fromData.factoryCode){
    	this.$message.error('请选择工厂');
    	return false;
      }
      if(!this.fromData.inventoryCode){
        this.$message.error('请选择工厂库存地');
        return false;
      }
      if(!this.fromData.customerCode){
        this.$message.error('请选择客户');
        return false;
      }
      this.searchCriteria.factoryId = this.fromData.factoryId;
      this.searchCriteria.factoryCode = this.fromData.factoryCode;
      this.searchCriteria.factoryDesc = this.fromData.factoryDesc;
      this.searchCriteria.inventoryId = this.fromData.inventoryId;
      this.dialogSelectMatters = true;
    },
    uploadBtn(){
      if(!this.fromData.factoryCode){
        this.$message.error('请选择工厂');
        return false;
      }
      if(!this.fromData.inventoryCode){
        this.$message.error('请选择工厂库存地');
        return false;
      }
      if(!this.fromData.customerCode){
        this.$message.error('请选择客户');
        return false;
      }
      this.postExcelData = {
        "factoryId":this.fromData.factoryId,
        "factoryCode":this.fromData.factoryCode,
        "factoryDesc":this.fromData.factoryDesc,
        "inventoryId":this.fromData.inventoryId,
        "inventoryCode":this.fromData.inventoryCode,
        "inventoryDesc":this.fromData.inventoryDesc,
      };
      this.$refs.actionbtn.uploadDialog = true;
    },
		//删除
		del(){
		  this.$refs.editTabList.getSelectEvent();
		  let delList = this.$refs.editTabList.checkedList;
		  if(delList.length < 1){
		  this.$message.error('请选择需要删除的记录');
		  }else{
		    this.$confirm('确认删除已选数据, 是否继续?', '提示', {
		      confirmButtonText: '确定',
		      cancelButtonText: '取消',
		      type: 'warning'
		    }).then(() => {
		      delList.forEach((item)=>{
		      let nowIndex = this.selectedMatterStockList.findIndex(v=>v.materialId === item.materialId);
		      if(nowIndex != -1){
		        this.$store.state.cache.selectedMatterStockList.splice(nowIndex,1);
		      }
		      })
		    });
		  }
		},
    //上传excel
    uploadExcel(res){
      console.log(res,6666);
      if(!res.data) return;
      let list = res.data.rightData;
      list.forEach((item)=>{
        let resIndex = this.selectedList.findIndex(v=>v.materialCode === item.materialCode);
        if(resIndex != -1){//存在相加
          let quantity = item.quantity +this.selectedList[resIndex].quantity;
          this.$set(this.selectedList[resIndex],'quantity',quantity);
        }else{
          let objData = {
            basicUnitCode: item.basicUnitCode,
            basicUnitDesc: item.basicUnitDesc,
            basicUnitId: item.basicUnitId,
            materialCode: item.materialCode,
            materialDesc: item.materialDesc,
            materialId: item.materialId,
            standardCurrAmount: item.purchasePrice,//价格
            quantity: item.quantity,//数量
            materialGroupDesc: item.materialGroupDesc,//物料组描述
            materialGroupId:item.materialGroupId,//物料组IE
            materialTypeId: item.materialTypeId,//物料类型
            materialTypeName: item.materialTypeName,
            "factoryCode":this.fromData.factoryCode,//工厂
            "factoryDesc":this.fromData.factoryDesc,
            "factoryId":this.fromData.factoryId,
            "inventoryCode":this.fromData.inventoryCode,//库存地
            "inventoryDesc":this.fromData.inventoryDes,
            "inventoryId":this.fromData.inventoryId,
            "customerCode":this.noFromData.customerCode,//客户
            "customerDesc":this.noFromData.customerDesc,
            "customerId":this.noFromData.customerId,
          };
          this.selectedList.push(objData);
        }
      });

      //错误的
      let failData = res.data.failData;
      if(failData.length){
        this.isExcelError = true;
        this.excelErrorList = failData;
      }
    },
		//判断当前输入数量是否大于库存数量
		isMaxNum(item,maxNum,index){
			if(item){
				item = item+'';
				item = item.replace(/[^\d]/g,'');
				if(item > maxNum) item = maxNum;
				this.$set(this.selectMatterList[index],'quantity',item);
			}
		}
	}

}
</script>

<style>
</style>
